(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('finishedGoodsOpportunityBySavings', finishedGoodsOpportunityBySavings);

	function finishedGoodsOpportunityBySavings($rootScope, $scope, $state, $location, redirectParamsService,
			leanFilterService, tableRenderService, $timeout, tableService, navigationService, pageTimingService, storeService, columnsService, flexColumns) {
		var vm = this;
		var unsubscribe;

		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var pinnedColumnList = [];
		var columnList = columns();

		var reportSettingsName = 'pfep-all-finished-goods';

		var extraParams = [{
			showExcel: true,
			excelReportName: 'Opportunity'
		},{
			name: 'reportRule',
			value: 'targetSavings'
		}];
		var rendererParams = {
			uomId: 'purchasingUOM',
			multiFactory: true,
			specificTaskType: 'task'
		};

		vm.reportName = 'PFEP: Finished goods';
		vm.showExcel = true;

		vm.getData = getData;
		vm.getMeta = getMeta;
		vm.broadcastExcel = broadcastExcel;

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Manufactured Item Opportunities');
				timingCalled = true;
			}
		}

		var defaultFilters = [
			{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true },
			{ id: 'itemGroupNdx', values: [leanFilterService.leanDnaAllSelected] }
		];
		var siteFilter = leanFilterService.filterDefinitions['Factory'];
		siteFilter.type = 'multiselect';
		siteFilter.removable = false;
		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = true;
		var filters = {};
		filters.multiSelectFilters = [
			leanFilterService.filterDefinitions['BusinessUnit'],
			leanFilterService.filterDefinitions['Division'],
			leanFilterService.filterDefinitions['Entity'],
			siteFilter,
			leanFilterService.filterDefinitions['Item Group'],
			leanFilterService.filterDefinitions['Planner'],
			leanFilterService.filterDefinitions['ERP Order Policy'],
			leanFilterService.filterDefinitions['MaterialGroup'],
			leanFilterService.filterDefinitions['MaterialType'],
			leanFilterService.filterDefinitions['TaskStatus'],
			leanFilterService.filterDefinitions['TaskCategory'],
			leanFilterService.filterDefinitions['Responsible'],
			leanFilterService.filterDefinitions['Build Model Recommendation']
		];
		filters = leanFilterService.addFlexFiltersBySourceType(['item'], filters);
		leanFilterService.setAllFilterLists(filters);

		function getMeta() {
			return {
				reportSettingsId: reportSettingsId,
				reportSettingsName: reportSettingsName,
				noPaging: false,
				pageSize: 50,
				defaultSort: 'estimatedSavings',
				defaultSortDirection: 'desc',
				defaultFilters: defaultFilters,
				rendererParams: rendererParams,
				extraParams: extraParams,
				columns: columnList,
				reportUrl: '{0}/ItemReport/Opportunities/FinishedGoodsTargetSavings',
				pinnedColumns: pinnedColumnList,
				hideSearch: false,
				footer: false,
				setColumnDefaults: true,
				excelRequest: true,
				useReportBuilderForExcel: true,
				excelReportName: 'Manufactured Item Opportunity',
				hasMandatoryFilters: true
			};
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;

				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {
				columns: getExcelColumns(),
				doChooseColumns: true,
				exportFileName: reportSettingsId ? vm.reportName : undefined
			});
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, getReportColumns()).then(function (response) {
				getDataCalled = true;
				return response;
			});
		}

		function getReportColumns() {
			var newColumns = [
				'daysDisplayType', 'orderPolicyValue'
			];
			newColumns = _.map(newColumns, function(val) {
				return {id: val};
			});
			return columns().concat(newColumns);
		}

		function getExcelColumns() {
			var newColumns = [
				'replenishmentMethodType', 'itemGroupName',
				'analysisDemandNext90Days', 'totalOnOrderQuantityFloat', 'analysisReorderPointEffectiveDate',
				'earlyDeliveriesLast7DaysValue', 'analysisExcessOnHandQuantityFloat', 'excessOnHandValue',
				'analysisExcessOnHandOverLTValue', 'analysisExcessOnOrderQuantityFloat', 'excessOnOrderValue',
				'analysisExcessOnOrderOverLTValue', 'overMaxValue', 'minMaxResizeSavings', 'analysisMultipleLeadTimeFloat',
				'qtyOfOpportunity', 'analysisTargetInventoryQtyOneYear', 'qtyReductionOpportunity', 'quotedPrice',
				'orderMultipleFloat', 'orderIntervalInt', 'analysisOrderIntervalInt', 'minimumOrderQuantityFloat',
				'analysisSafetyFactorFloat', 'analysisLeadTimeReqFloat', 'analysisLTRPlusSSFloat',
				'analysisVariabilityFloat', 'analysisDailyDemandStdDevFloat', 'safetyTimeFloat',
				'calculatedTriggerPoint', 'deadStockFlag', 'weeklyInventoryDelta', 'deltaWeeklyExcessOnHandValue',
				'deltaWeeklyExcessOnOrderValue', 'monthlyUsageDelta', 'actionSubject', 'actionOwner',
				'orderPolicyValue', 'pastDemandValue', 'futureDemandValue',
				'avgInventoryLast12Months', 'totalOnHandValue'
			];
			newColumns = _.map(newColumns, function(val) {
				return {id: val};
			});
			return columns().concat(newColumns);
		}

		function columns() {
			var columns = [
				{
					id: 'actionStatus',
					display: 'Task Status',
					renderer: tableRenderService.statusWithCircle,
					pinnedLeft: true,
					sort: false,
					width: 80
				}, {
					id: 'itemCode',
					display: 'Item Code',
					renderer: tableRenderService.itemCode,
					itemType: 'Manufactured',
					pinnedLeft: true,
					width: 150
				}, {
					id: 'itemGroupName',
					display: 'Item Group',
					width: 150
				}, {
					id: 'planner',
					display: 'Planner',
					width: 100
				}, {
					id: 'factoryName',
					display: 'Site',
					width: 120
				}, {
					id: 'safetyStockFloat',
					display: 'Safety Stock',
					renderer: tableRenderService.integer,
					width: 80
				}, {
					id: 'analysisSafetyStockLevelFloat',
					display: 'Recommended Safety Stock',
					renderer: tableRenderService.integer,
					width: 120
				}, {
					id: 'analysisTargetInventoryQty',
					display: 'Target Qty',
					renderer: tableRenderService.integer,
					width: 80
				}, {
					id: 'estimatedSavings',
					display: 'Estimated Savings',
					renderer: tableRenderService.currency,
					width: 80,
					sortDefaultReverse: true
				}, {
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					renderer: tableRenderService.onHand,
					itemType: 'manufactured',
					width: 80,
					show: false
				}, {
					id: 'costPerItemFloat',
					display: 'Unit Price',
					renderer: tableRenderService.currency,
					keepAllDecimals: true,
					width: 80
				}, {
					id: 'purchasingUOM',
					display: 'UOM',
					width: 80
				}, {
					id: 'abcClass',
					display: 'ABC Rank',
					show: false,
					width: 80
				}, {
					id: 'abcAnalysisType',
					display: 'Proposed ABC',
					width: 80
				}, {
					id: 'analysisXYZClass',
					display: 'Calculated XYZ Rank',
					width: 80,
					show: false
				}, {
					id: 'weeklyOpportunityDelta',
					display: 'Weekly Opportunity Change',
					class: 'alignRight',
					renderer: tableRenderService.ppvRenderer,
					width: 80,
					show: false
				}, {
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					show: false,
					renderer: tableRenderService.hyperlinkShortage
				}, {
					id: 'totalOnOrderValue',
					display: 'Total On Order Value',
					width: 80,
					show: false,
					renderer: tableRenderService.onOrderValue
				}, {
					id: 'totalOnHandQuantityFloat',
					display: 'Total On Hand Qty',
					renderer: tableRenderService.onHand,
					onHandType: 'integer-uom',
					itemType: 'manufactured',
					shouldGotoUnrestrictedFilter: false,
					show: true,
					width: 80
				}, {
					id: 'currentOnHandCostFloat',
					display: 'Total On Hand Value',
					renderer: tableRenderService.currency,
					show: false,
					width: 80
				}, {
					id: 'daysOfInventoryBackwards',
					display: 'Days of Inventory Backward',
					renderer: tableRenderService.integer,
					show: false,
					width: 80
				}, {
					id: 'daysOfInventoryForwards',
					display: 'Days of Inventory Forward',
					renderer: tableRenderService.integer,
					show: false,
					width: 80
				}, {
					id: 'productHierarchy',
					display: 'Product Hierarchy',
					show: false,
					width: 80
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				}, {
					id: 'externalMaterialGroup',
					display: 'External Material Group',
					show: false,
					width: 80
				}];
			columns = columns.concat(columnsService({
				analysisAvgDailyDemandFloat: { show: false, usingOrders: true },
				analysisAvgMonthlyDemandFloat: { show: false, usingOrders: true },
				isVmi: 0
			}));
			columns = columns.concat([{
				id: 'leadTimeInDaysFloat',
				display: 'Lead Time',
				renderer: tableRenderService.leadTime,
				show: false,
				width: 80
			}, {
				id: 'recommendedBuildModel',
				display: 'Build Model Recommendation',
				show: false,
				width: 100
			}, {
				id: 'currentReOrderPoint',
				display: 'Reorder Point',
				width: 100,
				renderer: tableRenderService.integer,
				show: false
			}, {
				id: 'recommendedReorderPointInt',
				display: 'Recommended Reorder Point',
				width: 120,
				renderer: tableRenderService.integer,
				show: false
			}
			]);

			if ($rootScope.authz.isLeanDNAAdmin()) {
				columns.splice(
					_.findIndex(columns, function (col) {
						return col.id === 'analysisAvgDailyDemandFloat';
					}),
					0,
					{
						id: 'analysisDailyDemandStdDevFloat',
						display: 'Weekly Demand Std. Dev',
						multiplier: 5,
						renderer: tableRenderService.decimal,
						width: 80,
						show: false
					}
				);
			}
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			return columns;
		}
	}
})();
